import { useCadastrarEditarProdutoContext } from "../../../../contexts/CadastrarEditarProdutoContext";
import { ConfiguracaoPizzaContainer } from "../../../../containers/ConfiguracaoPizzaContainer";
import { ConfiguracaoBordasContainer } from "../../../../containers/ConfiguracaoBordasContainer";
import { ConfiguracaoSaboresContainer } from "../../../../containers/ConfiguracaoSaboresContainer";
import { ControleEstoqueContainer } from "../../../../containers/ControleEstoqueContainer";
import { ConfiguracaoMassasContainer } from "../../../../containers/ConfiguracaoMassasContainer";
import { ConfiguracaoKDSContainer } from "../../../../containers/ConfiguracaoKDSContainer";
import { ConfiguracaoAdicionaisContainer } from "../../../../containers/ConfiguracaoAdicionaisContainer";
import { ConfiguracaoImpostoContainer } from "../../../../containers/ConfiguracaoImpostoContainer";

interface CadastrarPizzaContainerProps {

}

export const CadastrarPizzaContainer = ({ }: CadastrarPizzaContainerProps) => {
    const { step } = useCadastrarEditarProdutoContext();

    return (
        <>
            {step == 0 && (
                <ConfiguracaoPizzaContainer />
            )}
            {step == 1 && (
                <ControleEstoqueContainer />
            )}
            {step == 2 && (
                <ConfiguracaoKDSContainer />
            )}
            {step == 3 && (
                <ConfiguracaoMassasContainer />
            )}
            {step == 4 && (
                <ConfiguracaoBordasContainer />
            )}
            {step == 5 && (
                <ConfiguracaoSaboresContainer />
            )}
            {step == 6 && (
                <ConfiguracaoAdicionaisContainer />
            )}
            {step == 7 && (
                <ConfiguracaoImpostoContainer />
            )}
        </>
    );
}
